import type { FulfillmentTypeContainerDeliveryChargeDeleteResponseType } from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useFulfillmentTypeContainerDeliveryChargeDelete = (
  fulfillmentTypeContainerDeliveryChargeId: number,
) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: () =>
      apiV2Request({
        user,
        business,
        method: "delete",
        path: `fulfillment-type-container-delivery-charge/${fulfillmentTypeContainerDeliveryChargeId}`,
      }).then(
        (response) =>
          apiV2AssertResponse(response)
            .data as FulfillmentTypeContainerDeliveryChargeDeleteResponseType,
      ),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.FulfillmentTypeContainerDeliveryCharge,
          fulfillmentTypeContainerDeliveryChargeId,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.FulfillmentTypeContainerDeliveryCharge,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.FulfillmentType],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.FulfillmentType],
      });
    },
  });
};
